
import Layout from "@/components/layout/Layout";

const TermsOfService = () => (
  <Layout>
    <div className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
      <p className="mb-4">
        By using AI Nexus, you agree to abide by the following terms and conditions. Please read them carefully.
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2">1. Use of Service</h2>
      <p className="mb-4">
        You must use our services in compliance with all applicable laws and regulations. Unauthorized use or access is strictly prohibited.
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2">2. Accounts</h2>
      <p className="mb-4">
        You are responsible for maintaining the confidentiality of your account. You must notify us immediately of any unauthorized use of your account.
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2">3. Limitation of Liability</h2>
      <p className="mb-4">
        AI Nexus and its affiliates will not be liable for any indirect, incidental, or consequential damages arising from the use or inability to use our services.
      </p>
      <h2 className="text-xl font-semibold mt-6 mb-2">4. Changes to Terms</h2>
      <p className="mb-4">
        We may update these terms at any time. Continued use of the service indicates acceptance of the updated terms.
      </p>
      <p className="mt-8 text-gray-500 text-sm">
        Last updated: April 22, 2025
      </p>
    </div>
  </Layout>
);

export default TermsOfService;
